import { Icon } from '@/common/components/Icon'
import { Card } from '@/components/ui'
import { cn } from '@/lib/utils'

interface DiscountCode {
  code: string
  count: number
}

interface DiscountCodesWidgetProps {
  className?: string
  codes?: DiscountCode[]
  subtitle?: string
}

export const DiscountCodesWidget: React.FC<DiscountCodesWidgetProps> = ({
  className,
  codes,
  subtitle = 'Last 6 Months',
}) => {
  return (
    <Card
      className={cn(
        'flex overflow-hidden border-2 border-white/10 bg-black/60 py-[30px] pl-[30px] pr-2 backdrop-blur-sm',
        className,
      )}
    >
      <div className="flex min-h-0 flex-1 flex-col">
        {/* Header */}
        <div className="flex items-center gap-2.5 pr-[22px]">
          <div className="flex relative size-11 shrink-0 items-center justify-center rounded-3xl border border-white/20">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 h-1/2 bg-accent-1/40 rounded-3xl blur-sm" />
            <Icon
              icon="ticket-3"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              className="text-accent-1"
            />
          </div>
          <div className="flex flex-1 flex-col">
            <span className="text-title-xxs text-monochrome-1">
              Top Discount Codes Applied
            </span>
            <span className="text-body-medium text-monochrome-2">
              {subtitle}
            </span>
          </div>
        </div>

        {/* Codes List */}
        <div className="mt-[30px] flex flex-1 flex-col gap-[15px] overflow-y-auto max-h-[325px] pr-[22px]">
          {codes?.map((item, index) => (
            <div key={item.code} className="flex flex-col gap-[15px]">
              <div className="flex items-center justify-between">
                <span className="text-button-m text-monochrome-1">
                  {item.code}
                </span>
                <span className="text-button-m text-monochrome-1">
                  {item.count.toLocaleString()}
                </span>
              </div>
              {index < codes.length - 1 && (
                <div className="h-px w-full bg-white/10" />
              )}
            </div>
          ))}
        </div>
      </div>
    </Card>
  )
}
